import Call24x24Icon from './ic_call_24x24.svg';
import Folder32x32Icon from './ic_folder_32x32.svg';
import Globe24x24Icon from './ic_globe_24x24.svg';
import ImageAdd24x24Icon from './ic_image_add_24x24.svg';
import Mail40x40Icon from './ic_mail_40x40.svg';
import Send24x24Icon from './ic_send_24x24.svg';
import Thunder20x20Icon from './ic_thunder_20x20.svg';
import Timer24x24Icon from './ic_timer_24x24.svg';
import Quotation32x32Icon from './ic_utility_bill.svg';
import Quotation16x16Icon from './ic_utility_bill_16x16.svg';

export {
  Call24x24Icon,
  Folder32x32Icon,
  Globe24x24Icon,
  ImageAdd24x24Icon,
  Mail40x40Icon,
  Quotation16x16Icon,
  Quotation32x32Icon,
  Send24x24Icon,
  Thunder20x20Icon,
  Timer24x24Icon,
};
